var map = {
	"./de-DE.json": [
		1795,
		2
	],
	"./en-GB.json": [
		1796,
		3
	],
	"./en-US.json": [
		1797,
		4
	],
	"./es-419.json": [
		1798,
		5
	],
	"./es-ES.json": [
		1799,
		6
	],
	"./fr-CA.json": [
		1800,
		7
	],
	"./fr-FR.json": [
		1801,
		8
	],
	"./id-ID.json": [
		1802,
		9
	],
	"./it-IT.json": [
		1803,
		10
	],
	"./ja-JP.json": [
		1804,
		11
	],
	"./nl-NL.json": [
		1805,
		12
	],
	"./pt-BR.json": [
		1806,
		13
	],
	"./zh-CN.json": [
		1807,
		14
	],
	"./zh-Hans-CN.json": [
		1808,
		15
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 836;
module.exports = webpackAsyncContext;